
import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Minus, Plus } from 'lucide-react';

const FONT_SCALES = [
  { value: 0.75, label: 'صغير جداً' },
  { value: 0.875, label: 'صغير' },
  { value: 1, label: 'عادي' },
  { value: 1.125, label: 'كبير' },
  { value: 1.25, label: 'كبير جداً' },
  { value: 1.5, label: 'عملاق' }
];

export const FontSizeControl = () => {
  const [currentScale, setCurrentScale] = useState(1);

  useEffect(() => {
    const savedScale = localStorage.getItem('font-scale');
    if (savedScale) {
      const scale = parseFloat(savedScale);
      setCurrentScale(scale);
      applyFontScale(scale);
    }
  }, []);

  const applyFontScale = (scale: number) => {
    document.documentElement.style.setProperty('--font-scale', scale.toString());
  };

  const changeScale = (newScale: number) => {
    setCurrentScale(newScale);
    applyFontScale(newScale);
    localStorage.setItem('font-scale', newScale.toString());
  };

  const decreaseScale = () => {
    const currentIndex = FONT_SCALES.findIndex(s => s.value === currentScale);
    if (currentIndex > 0) {
      changeScale(FONT_SCALES[currentIndex - 1].value);
    }
  };

  const increaseScale = () => {
    const currentIndex = FONT_SCALES.findIndex(s => s.value === currentScale);
    if (currentIndex < FONT_SCALES.length - 1) {
      changeScale(FONT_SCALES[currentIndex + 1].value);
    }
  };

  const currentScaleLabel = FONT_SCALES.find(s => s.value === currentScale)?.label || 'عادي';

  return (
    <div className="flex items-center gap-1 bg-background rounded-lg p-1 shadow-sm border">
      <Button
        variant="ghost"
        size="sm"
        onClick={decreaseScale}
        disabled={currentScale <= FONT_SCALES[0].value}
        className="h-7 w-7 p-0 hover:bg-accent"
        title="تصغير الخط"
      >
        <Minus className="h-3 w-3" />
      </Button>
      
      <span className="text-xs font-medium min-w-[60px] text-center px-1">
        {currentScaleLabel}
      </span>
      
      <Button
        variant="ghost"
        size="sm"
        onClick={increaseScale}
        disabled={currentScale >= FONT_SCALES[FONT_SCALES.length - 1].value}
        className="h-7 w-7 p-0 hover:bg-accent"
        title="تكبير الخط"
      >
        <Plus className="h-3 w-3" />
      </Button>
    </div>
  );
};
